<template>
  <div class="page-top-section" :class="[ $route.name !== 'landing' ? 'not-landing' : '' ]">
    <div class="section-indicator" v-if="false">
      <span></span>
      <span></span>
      <span></span>
      <!-- <div style="color:gray;">{{ scrollPos }}</div> -->
    </div>

    <div class="container-wrapper" v-if="$route.name === 'landing'">
      <div v-if="loading === false" data-aos="fade-in" data-aos-once="true" style="height:100%;">
        <div class="slick-wrapper" data-aos="fade-in" data-aos-once="true" style="height:100%;">
          <slick ref="slick" :options="slickOptions">
            <div class="item-wrapper" v-for="item in items" v-bind:key="item.title" :caption="item.title" :href="item.image.path" :src="item.image.path" style="background-color:black;">
              <div class="item-image item-image-desktop" v-if="isDesktop" data-pin-nopin="true" :style="{ 'background-image': 'url(' + item.image.path + ')' }" />
              <div class="item-image item-image-mobile" v-else-if="item.image_mobile" data-pin-nopin="true" :style="{ 'background-image': 'url(' + item.image_mobile.path + ')' }" />
              <div class="item-image item-image-desktop" v-else data-pin-nopin="true" :style="{ 'background-image': 'url(' + item.image.path + ')' }" />
              <div class="item-slogan">
                <img src="../assets/chaos.png" width="200" class="img-responsive" />
              </div>
            </div>
            <!-- </lightbox> -->
          </slick>
        </div>
      </div>
    </div>

    <section class="scroll-down" v-if="$route.name === 'landing'">
      <a @click="$scrollTo('#section-about', { offset: -30 })">
        <div class="content">
          <div class="circle">
            <i class="fa fa-angle-double-down"></i>
          </div>
        </div>
      </a>
    </section>

    <section class="arrow-down" v-if="false">
      <a @click="$scrollTo('#section-about', { offset: -30 })"><span></span></a>
    </section>
  </div>
  </template>

  <script>
  import Singulo from '@/apis/Singulo'
  import Slick from 'vue-slick'
  import Lightbox from 'vue-lightbox'

  export default {
    name: 'landing',
    components: {
      Slick,
      Lightbox
    },
    data () {
      return {
        isDesktop: true,
        slickOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          fade: true,
          speed: 1000,
          swipe: false,
          swipeToSlide: false,
          touchMove: false,
          autoplay: true,
          autoplaySpeed: 4000,
          pauseOnHover: false,
          pauseOnFocus: false,
          pauseOnDotsHover: false,
          focusOnSelect: false,
          responsive: [
            {
              breakpoint: 1008,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            }, {
              // 768 = tablet (not break yet)
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }, {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }
          ]
        },
        items: [],
        itemsEnded: false,
        error: undefined,
        loading: true,
        scrollPos: 0
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
      // console.log('created TopSection.vue')
    },
    mounted () {
      // console.log('mounted TopSection.vue')
      // window.GA('send', 'pageview')

      // on event resize
      this.isDesktop = (window.innerWidth >= 768)
      window.addEventListener('resize', function (event) {
        // console.log('on viewport change')
        this.isDesktop = (event.target.innerWidth >= 768)
      }.bind(this))

      this.refresh()
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this),

      next () {
        if (this.$refs.slick) {
          this.$refs.slick.next()
        }
      },
      prev () {
        if (this.$refs.slick) {
          this.$refs.slick.prev()
        }
      },
      reInit () {
        if (this.$refs.slick) {
          this.$refs.slick.reSlick()
        }
      },
      getItems: function (onComplete) {
        this.loading = true
        this.error = undefined
        Singulo.carousel()
        .then((data) => {
          // console.log(data)
          onComplete(data)
          this.$nextTick(function () {
            this.reInit()
          })
          this.reInit()
          this.loading = false
        })
        .catch((error) => {
          this.error = error
          this.error = 'Unable to load, please kindly refresh the page.'
          this.loading = false
        })
      },
      refresh: function () {
        this.getItems((items) => {
          this.items = items
        })
      },
      renderYtSubscribeButton: function (channel) {
        /* global gapi */
        var container = document.getElementById('yt-button-container-render')
        var options = {
          'channel': channel,
          'layout': 'full'
        }
        gapi.ytsubscribe.render(container, options)
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-top-section {
  // height: 80%; // noc: full height
  height: 600px;
  position: relative;

  &.not-landing {
    height: 100px; // noc: zero height
  }

  .container-wrapper {
    max-height: 100%; // noc: full height
    height: 100%; // noc: full height
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .section-indicator {
    position: fixed;
    left: 0px;
    top: 50%;

    span {
      display: block;
      clear: both;
      overflow: hidden;
      width: 9px;
      height: 9px;
      border-radius: 5px;
      background-color: $color-white;
      margin: 10px;
      border: 1px solid $color-gray;

      &.is-active {
        background-color: $color-gray;
      }
    }
  }
}

.landing-logo {
  width: 100px;
  margin: 15px;
  margin-bottom: 0;
  vertical-align: top;
  @media screen and (min-width: $tablet) {
    width: auto;
    margin: 0;
  }
}

.subscribe-wrapper {
  padding-top: 10px;
  padding-left: 0px;
  margin: 15px;
  margin-top: 0px;
  // display: inline-block;

  @media screen and (min-width: $mobile-min) {
  }

  @media screen and (max-width: $mobile) and (orientation: landscape) {
    // display: block;
    margin-top: 0px;
  }

  @media screen and (min-width: $tablet) {
    // display: block;
    padding-left: 6%;
    margin: 0;
    margin-top: 20px;
  }

  @media screen and (min-width: $desktop) {
    padding-left: 7%;
  }

  i.fa {
    color: $color-white;
    margin-top: 0;
    @media screen and (min-width: $tablet) {
      margin-top: 20px;
    }
  }
}

/* slick */

.slick-wrapper-outer {
  height: 100%;
  overflow-x: visible;
  overflow-y: visible;
  position: relative;

  img {
    height: 100%;
    width: auto;
    max-height: 100%;
    max-width: 500%;
    position: absolute;
    // z-index: 1;
    bottom: 10%;
    left: -2%;

    // landscape mobile
    @media screen and (max-width: $mobile) and (orientation: landscape) {
      height: auto;
      width: 100%;
      max-height: 400%;
      max-width: 100%;
      left: 20%;
      bottom: 0%;
    }

    @media screen and (min-width: $tablet) {
      left: 8%;
      bottom: 0%;
    }
  }
}

.slick-wrapper {
  height: 100% !important; // noc: full height

  .slick {
    height: 100%; // noc: full height
  }

  .slick-slider {
    width: 100%;
    height: 100%;

    .slick-track, .slick-list {
      width: 100%;
      height: 100%;
    }
  }

  .slick-initialized {
    .slick-slide {
      width: 100%;
      height: 100% !important;

      div {
        width: 100%;
        height: 100% !important;

        div.item-wrapper {
          width: 100%;
          height: 100% !important;
          background-color: $color-gray;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: cover;
          overflow-y: hidden;

          div.item-slogan {
            position: absolute;
            top: 38%;

            img {
              width: 90%;

              @media screen and (min-width: $desktop) {
                width: 50%;
              }
            }
          }

          img, .item-image {
            margin: auto;

            &.item-image-desktop,
            &.item-image-mobile {
              width: 100%; // noc: full width
              height: 100%; // noc: full height
              background-repeat: no-repeat;
              background-position: center center;
              background-size: cover;
            }
          }
        }
      }
    }
  }
}

$slick-control-width: 60px;
$slick-control-height: 80px;
$slide-control-offset-side: 20px;

.slick-prev, .slick-next {
  display: none !important; // hide
  z-index: 100;
  width: ($slick-control-width * 2 / 3);
  height: ($slick-control-height * 2 / 3);
  color: black;
  transition: all .2s ease-in;

  @media screen and (min-width: $tablet) {
    width: $slick-control-width;
    height: $slick-control-height;
  }

  &, &:focus {
    background: rgba(0,0,0,0.3);
  }

  &:hover {
    background: rgba(0,0,0,0.5);
  }

  &.slick-disabled {
    background: rgba(0,0,0,0.1);
  }

  &:before {
    color: rgba(255,255,255,0.5);
    // content: '\279C';
    content: '\25BA';
    font-size: 1rem;

    @media screen and (min-width: $tablet) {
      font-size: 2rem;
    }
  }
}

.slick-prev {
  left: ($slide-control-offset-side / 2) !important;
  top: calc(50% - (#{$slick-control-height} / 2.0));
  transform: rotate(180deg);

  @media screen and (min-width: $tablet) {
    left: $slide-control-offset-side !important;
  }
}

.slick-next {
  right: ($slide-control-offset-side / 2) !important;

  @media screen and (min-width: $tablet) {
    right: $slide-control-offset-side !important;
  }
}

.slick-dotted.slick-slider {
  margin-bottom: 0px;
}

.slick-dots {
  display: none !important; // hide
  bottom: 60px;

  li {
    background-color: rgba(255,255,255,0.1);
    border-radius: 10px;

    button:before,
    &.slick-active button:before {
      color: rgba(255,255,255,0.8);
      // content: '\25FE'; // a filled square
    }

    &.slick-active button:before {
      opacity: 1.0;
      color: white;
    }

    button {
      &:before {
        opacity: .40;
      }
    }
  }
}

// arrow

.scroll-down {
  text-align: center;
  position: relative;

  a {

    div.content {
      position: absolute;
      bottom: 10px;
      left: 50%;
      margin-left: -20px;
      color: $color-white-transparent;

      @media screen and (min-width: $tablet) {
        color: $color-black-transparent;
      }

      @keyframes scroll-text-animate {
        0% {
          transform: translate(0, 0);
        }
        40% {
          transform: translate(0px, -5px);
        }
        80% {
          transform: translate(0, 0);
        }
      }

      .circle {
        color: $color-gray-light;
        border-radius: 20px;
        font-size: 2rem;
        background-color: transparent;
        width: 40px;
        height: 40px;
        animation: scroll-text-animate 2.0s infinite;

        .fa {
          padding: 3px;
        }
      }
    }
  }
}

.arrow-down {
  text-align: center;
  position: relative;

  a {
    padding-top: 60px;

    span {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 15px;
      height: 15px;
      margin-left: -8px;
      border-left: 1px solid $color-gray;
      border-bottom: 1px solid $color-gray;
      transform: rotate(-45deg);
      animation: arrow-down-animate 1.5s infinite;
      box-sizing: border-box;
    }
    @keyframes arrow-down-animate {
      0% {
        transform: rotate(-45deg) translate(0, 0);
      }
      30% {
        transform: rotate(-45deg) translate(-10px, 10px);
      }
      80% {
        transform: rotate(-45deg) translate(0, 0);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// TopSection.vue?777d8640